import { Form } from 'formik';
import { styled, css } from 'styled-components';

import { FormGroup } from '@blueprintjs/core';

const formLayoutStyles = css`
  display: flex;
  flex-direction: column;
  flex: 1 1 1px;
`;

export const StyledForm = styled(Form)`
  ${formLayoutStyles}
`;

export const StyledNativeForm = styled.form`
  ${formLayoutStyles}
`;

export const StyledFormContent = styled.div<{ $fit?: boolean }>`
  flex: 1 1 1px;
  padding: ${({ theme: { spacing } }) => `${spacing(3)}px ${spacing(2)}px`};
  overflow-y: auto;
  @media screen and (min-width: 1400px) {
    width: ${({ $fit }) => $fit && '40%'};
  }
`;

const requiredStyles = css`
  &::after {
    content: ' *';
  }
`;

export const StyledFormGroup = styled(FormGroup)<{ $isRequired?: boolean }>`
  label {
    font-size: ${({ theme }) => theme.font.size.md}rem;
    ${({ $isRequired }) => $isRequired && requiredStyles}
  }
`;
